import React from 'react';
import styled from 'styled-components';
import { Intro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { ChartSeries } from './ChartSeries';
import { Button, ButtonLink } from './../Form/index';
import { HousePrice, RepaymentOptions } from './LeftPanel';
import { ClientLoan } from './ClientLoan';

const titleRepayment = [
  `Enter some details about your client\'s property and the repayments they might look
  to make to see the effect it could have on ther loan and the equity in their home.`
];

const PartialRepayment = styled.div`
  h1 { text-align: center; color: #0a2f70; }
`;

export const PartialRepaymentComponent = ({ screen, partialRepayment, onChangeInput }) => {
  return (
    <PartialRepayment>
      <h1>Remaining equity calculator</h1>
      <Intro title={titleRepayment} padding={20} />

      <OneColumnLayout>
        <div className="sidebar">
          <ClientLoan {...partialRepayment} onChangeInput={onChangeInput} />
          <HousePrice {...partialRepayment} onChangeInput={onChangeInput} />
          <RepaymentOptions {...partialRepayment} onChangeInput={onChangeInput} />
        </div>
        <div className="content">
          {/*<DebugSeries series={partialRepayment.output.series} />*/}
          {/*<pre>{JSON.stringify(partialRepayment.input, null, 2)}</pre>*/}
          <ChartSeries {...partialRepayment.output} />
        </div>
      </OneColumnLayout>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/'>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
        </ButtonPanel>
      )}
    </PartialRepayment>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/PartialRepaymentComponent.js